import { ReactNode, useState } from 'react';
import { FullscreenOutlined } from '@ant-design/icons';
import { Button, Modal, Popover, PopoverProps, Space } from 'antd';

const DEFAULT_WINDOW_SIZE = { width: 450, height: 350 };
export type Popover2ModalProps = Omit<PopoverProps, 'title' | 'content | trigger'> & {
  title?: string;
  titleContent?: ReactNode;
  content: ReactNode;
  width?: number;
  popoverWidth?: number;
  popoverHeight?: number | 'auto';
};

export const Popover2Modal = ({
  title,
  titleContent,
  content,
  width = 1100,
  popoverWidth = DEFAULT_WINDOW_SIZE.width,
  popoverHeight: contentHeight = DEFAULT_WINDOW_SIZE.height,
  children,
  ...restProps
}: Popover2ModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <>
      <Popover
        title={
          <>
            <span>{title}</span>
            <Space style={{ float: 'right' }} size="small">
              {titleContent}
              <Button
                icon={<FullscreenOutlined />}
                type="link"
                size="small"
                onClick={() => {
                  setIsModalOpen(true);
                  setIsPopoverOpen(false);
                }}
              >
                Expand
              </Button>
            </Space>
          </>
        }
        content={
          <div
            style={{
              height: contentHeight === 'auto' ? undefined : contentHeight,
              width: popoverWidth,
              overflow: 'auto',
            }}
          >
            {content}
          </div>
        }
        trigger="hover"
        {...restProps}
        onOpenChange={(open) => setIsPopoverOpen(open)}
        open={isPopoverOpen}
      >
        <span onClick={() => setIsModalOpen(true)}>{children}</span>
      </Popover>
      <Modal
        title={title}
        open={isModalOpen}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        width={width}
        closable
        centered
      >
        {content}
      </Modal>
    </>
  );
};
